import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '../icons'

const ArrowLeft = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.734 7.26a.88.88 0 0 1 0 1.26L11.191 12l3.543 3.48a.88.88 0 0 1 0 1.26.92.92 0 0 1-1.283 0l-4.185-4.11a.88.88 0 0 1 0-1.26l4.185-4.11a.92.92 0 0 1 1.283 0Z"
      fill={color}
    />
  </Svg>
)

export default ArrowLeft
